<template>
	<Modal title="Game over!">
		<p
			class="text-center"
			v-if="winner"
		><strong>{{ message }}</strong></p>
		<template v-slot:footer>
			<button
				class="btn btn-light"
				@click="$emit('settings')"
			>Settings</button>
			<button
				class="btn btn-light"
				@click="$emit('restart')"
			>New game</button>
			<button
				class="btn btn-light"
				data-dismiss="modal"
			>Close</button>
		</template>
	</Modal>
</template>

<script>
export default {
	props: ["kiddingMode", "winner"],
	computed: {
		message() {
			if (this.kiddingMode) return 'Board is full!';
			switch (this.winner) {
				case 1:
					return "Black wins!";

				case 2:
					return "White wins!";

				case 3:
					return "Draw!";

				default:
					HHUI.error("Invalid winner value " + winner);
					return "Invalid";
			}
		}
	}
};
</script>